import instance from "./apiClient";
import { apiRoutes } from "configs/apiRoutes";

interface KycDocumentPreviewResponse {
  previewUrl: string;
  mimeType: string;
  expiresAt: string;
}

export const getKycDocumentPreviewUrl = (
  userId: number,
  documentId: number,
) => {
  return instance.get<KycDocumentPreviewResponse>(
    apiRoutes.riskKycDocumentPreview(userId, documentId),
  );
};
